import { useState, useEffect, useRef, useMemo } from "react";
import PageSelection from "./components/PageSelection";
import OverviewDashboard from "./components/OverviewDashboard";
import EnergyConsumption from "./components/EnergyConsumption";
import WasteManagement from "./components/WasteManagement";
import CarbonFootprint from "./components/CarbonFootprint";
import Occupancy from "./components/Occupancy";
import Engineering from "./components/Engineering";
import Advertisement from "./components/Advertisement";
import { P } from "../../components/Common/Typo/typo";
import logofooter from "../../assets/logofooter.png";
import { UserBadge } from "./components/UserBadge";
import { useLocation } from "react-router-dom";
import qr from "../../assets/qr.png";
import { useAuthContext } from "../../auth";
import { guestLogin } from "../../auth";
import useSWR from "swr";
// import bgImg from "../../assets/OccupancyBG.png";

export function Dashboard() {
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [showHeader, setShowHeader] = useState<boolean>(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page");
  const { isLoggedIn } = useAuthContext();
  const intervalRef = useRef<NodeJS.Timeout>();
  const { data: adsData } = useSWR(["/v1/thaihealth/getting_ads_data/"]);

  // Preload Occupancy component
  const preloadedOccupancy = useMemo(() => <Occupancy />, []);

  const pageList = [
    {
      order: 1,
      name: "Overview Dashboard",
      component: <OverviewDashboard />,
    },
    {
      order: 2,
      name: "Energy Consumption",
      component: <EnergyConsumption />,
    },
    {
      order: 3,
      name: "Waste Management",
      component: <WasteManagement />,
    },
    {
      order: 4,
      name: "Carbon Footprint",
      component: <CarbonFootprint />,
    },
    {
      order: 5,
      name: "Occupancy",
      component: preloadedOccupancy,
    },
    // {
    //   order: 5,
    //   name: "Engineering",
    //   component: <Engineering />,
    // },
    {
      order: 6,
      name: "Advertisement",
      component: <Advertisement />,
    },
  ];

  if (!isLoggedIn) {
    guestLogin();
  }

  const startInterval = () => {
    // Clear any existing interval first
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const interval = setInterval(
      () => {
        setSelectedPage((prevSelectedPage) => {
          const nextPage = prevSelectedPage + 1;
          if (nextPage > pageList.length) {
            return 1;
          }
          return nextPage;
        });
      },
      selectedPage === pageList.length
        ? adsData?.duration_page * 1000 || 60000
        : 60000
    );

    intervalRef.current = interval;
  };

  useEffect(() => {
    if (page) {
      setSelectedPage(Number(page));
    } else {
      startInterval();

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [page, pageList.length, selectedPage, adsData?.duration_page]);

  const handlePageSelection = (pageOrder: number) => {
    setSelectedPage(pageOrder);
    // Restart the interval after manual selection
    startInterval();
  };

  const renderSelectedPage = () => {
    const selectedPageData = pageList.find(
      (page: any) => page.order === selectedPage
    );
    return selectedPageData?.component;
  };

  // Preload images
  // useEffect(() => {
  //   const img = new Image();
  //   img.src = bgImg;
  // }, []);

  return (
    <div className="flex flex-col justify-between relative h-screen">
      {/* Hidden preloaded Occupancy component */}
      <div className="hidden">
        <Occupancy />
      </div>
      {showHeader && (
        <div className="absolute bg-white w-full top-0 flex items-end justify-end">
          <UserBadge />
        </div>
      )}
      <div className="h-full flex flex-col">
        <PageSelection
          selectedPage={selectedPage}
          pageList={pageList}
          onPageSelect={handlePageSelection}
        />
        <div className="h-full w-full flex items-center justify-center">
          {renderSelectedPage()}
        </div>
      </div>
      <div>
        <div
          className="border-t-2 border-[#6F6F6E] flex justify-between items-center px-[24px] py-[4px]"
          style={{
            background:
              "linear-gradient(0deg, rgba(111, 111, 110, 0.60) -215%, #D5D5D3 164%)",
          }}
        >
          <div className="flex justify-center items-center gap-5 ml-5">
            <img src={qr} alt="Overview" className="h-[44px]" />
            <P fontSize="24px" color="#FFF">
              For Building access scan QR Code
            </P>
          </div>
          <div className="flex items-center gap-[10px]">
            <P fontSize="24px" color="#FFF">
              www.thaihealth.or.th
            </P>
            <P fontSize="24px" color="#FFF">
              02-343-1500
            </P>
          </div>
        </div>
      </div>
    </div>
  );
}
